import type { TicketPriority, TicketStatus } from '@services/tickets/types'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

import { TICKET_PRIORITY_TONE, TICKET_STATUS_TONE } from '../constants'

export function TicketStatusPill({ status }: { status: TicketStatus }) {
  const { t } = useTranslation('tickets')
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold',
        TICKET_STATUS_TONE[status] ?? 'bg-ink/[0.07] text-ink/60'
      )}
    >
      {t(`statuses.${status}`)}
    </span>
  )
}

export function TicketPriorityPill({ priority }: { priority: TicketPriority }) {
  const { t } = useTranslation('tickets')
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold',
        TICKET_PRIORITY_TONE[priority] ?? 'bg-ink/[0.07] text-ink/60'
      )}
    >
      {t(`priorities.${priority}`)}
    </span>
  )
}
